import React from "react";
import Header from "./components/Header";
import CreateTodo from "./components/CreateTodo";
import AllTodosKeep from "./components/AllTodosKeep";
import styled from "styled-components";
import DeleteTodo from "./components/DeleteTodo";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { selectUserName } from "./features/user/UserSlice";
import { useSelector } from "react-redux";
import ErrorPage from "./components/ErrorPage";

const App = () => {
  const userName = useSelector(selectUserName);
  return (
    <div className="App">
      <MainDiv>
        <Header />
        <Routes>
          <Route path="/" element={<AllTodosKeep />} />
          {!userName ? (
            <>
              <Route path="*" element={<ErrorPage />} />
            </>
          ) : (
            <>
              <Route path="/create" element={<CreateTodo />} />
              <Route path="/update/:id/" element={<CreateTodo />} />
              <Route path="/delete/:id/" element={<DeleteTodo />} />
            </>
          )}
        </Routes>
      </MainDiv>
    </div>
  );
};

export default App;
const MainDiv = styled.div`
  width: 100vw;
  background-color: rgb(255, 255, 255);
`;
